import React, { useEffect, useState, useRef } from "react";
import UserWrapper from "./user.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import Api from "api/Api";
import Toaster from "components/common/Toaster";
import AdvertisementForm from "components/advertisement/AdvertisementForm";

const buildSavePayload = data => {
  const files = [];
  const items = (data.items || []).map((item, sortOrder) => {
    const payload = {
      advertisementId: item.advertisementId || null,
      fileType: item.fileType,
      sortOrder,
      imageWidth: item.imageWidth ? Number(item.imageWidth) : null,
      imageHeight: item.imageHeight ? Number(item.imageHeight) : null
    };
    if (item.fileType === "TEXT") {
      payload.text = item.text?.trim();
    } else if (item.fileType === "IMAGE") {
      if (item.file) {
        payload.fileIndex = files.length;
        files.push(item.file);
      } else if (item.advertisementId) {
        payload.keepExisting = true;
      }
    } else if (item.fileType === "IMAGE_TEXT") {
      payload.text = item.text?.trim();
      if (item.file) {
        payload.fileIndex = files.length;
        files.push(item.file);
      } else if (item.advertisementId) {
        payload.keepExisting = true;
      }
    }
    return payload;
  });
  return { items, files };
};

const AdvertisementEdit = props => {
  const [editedData, setEditedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const deviceTokenIdParam = props.match.params.deviceTokenId;
  const isEditPath =
    props.location.pathname.includes("/advertisement/edit") ||
    props.location.pathname.includes("/store/advertisement/edit");

  const toaster = useRef();

  useEffect(() => {
    const fromState = props.location.state;
    if (fromState?.deviceTokenId) {
      setEditedData(fromState);
      return;
    }
    const id = deviceTokenIdParam || fromState?.deviceTokenId;
    if (isEditPath && id) {
      Api.get(`/admin/advertisement/detail?deviceTokenId=${id}`)
        .then(res => setEditedData(res.data.data))
        .catch(err => {
          if (toaster.current) toaster.current.error(err);
        });
    }
  }, [props.location.state, deviceTokenIdParam, isEditPath]);

  useEffect(() => {
    if (props.isStore && !props.storeId) {
      props.history.push("/store");
    }
  }, [props.isStore, props.storeId]);

  const submitFormHandler = (data, action) => {
    const { items, files } = buildSavePayload(data);

    const needsImage = items.some(
      i =>
        (i.fileType === "IMAGE" || i.fileType === "IMAGE_TEXT") &&
        i.fileIndex == null &&
        !i.keepExisting
    );
    if (needsImage) {
      if (toaster.current) {
        toaster.current.error("Please upload an image for each image slide");
      }
      return;
    }

    if (action === "add") {
      const deviceTokenIds = Array.isArray(data.device)
        ? data.device.map(d => d.id)
        : [data.device?.id].filter(Boolean);
      const body = { deviceTokenIds, items };
      const formData = new FormData();
      formData.append("itemsJson", JSON.stringify(body));
      files.forEach(file => formData.append("advertisementList", file));
      setLoading(true);
      Api.post("/admin/advertisement/add/mixed", formData)
        .then(response => {
          if (toaster.current) toaster.current.success(response.data.message);
          setTimeout(() => {
            props.history.push(
              !props.isStore ? "/advertisement" : "/store/advertisement"
            );
          }, 1000);
        })
        .catch(error => {
          setLoading(false);
          const msg =
            error?.response?.status === 404
              ? "Mixed scroller API not deployed yet — restart backend with latest code."
              : error?.response?.data?.message || error?.message || error;
          if (toaster.current) toaster.current.error(msg);
        });
    } else if (action === "edit") {
      const body = {
        deviceTokenId: data.device?.id,
        items,
        deletedAdvertisementIds: data.deletedAdvertisementIds || []
      };
      const formData = new FormData();
      formData.append("itemsJson", JSON.stringify(body));
      files.forEach(file => formData.append("advertisementList", file));
      setLoading(true);
      Api.put(
        `/admin/advertisement/edit?deviceTokenId=${data.device?.id}`,
        formData
      )
        .then(response => {
          if (toaster.current) toaster.current.success(response.data.message);
          setTimeout(() => {
            props.history.push(
              !props.isStore ? "/advertisement" : "/store/advertisement"
            );
          }, 1000);
        })
        .catch(error => {
          setLoading(false);
          const msg =
            error?.response?.status === 404
              ? "Scroller edit API not deployed yet — restart backend with latest code."
              : error?.response?.data?.message || error?.message || error;
          if (toaster.current) toaster.current.error(msg);
        });
    }
  };

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          title={
            !props.isStore
              ? "sidebar.advertisement"
              : `Advertisement Management (${props.storeName})`
          }
          className="plr-15"
          breadCrumb={[
            {
              name: !props.isStore
                ? "sidebar.dashboard"
                : "sidebar.storeDashboard"
            },
            { name: "sidebar.advertisement" },
            { name: isEditPath ? "action.edit" : "action.add" }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() =>
            props.history.push(
              !props.isStore ? "/advertisement" : "/store/advertisement"
            )
          }
        >
          <i className="fas fa-step-backward" /> Backward
        </div>
      </div>
      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span>
              {isEditPath ? "Edit" : "Add"} Scroller
            </div>
          </div>
          <div className="roe-card-body">
            <AdvertisementForm
              onSubmit={submitFormHandler}
              editedData={editedData}
              action={isEditPath ? "edit" : "add"}
              loading={loading}
              isStore={props.isStore}
              storeId={props.storeId}
              storeName={props.storeName}
              branchCount={props.branchCount}
              deviceCount={props.deviceCount}
              history={props.history}
            />
          </div>
        </div>
      </div>
      <Toaster ref={toaster} />
    </UserWrapper>
  );
};

const mapStateToProps = state => ({
  ...state.themeChanger,
  ...state.storeID
});

export default connect(mapStateToProps, null)(AdvertisementEdit);
